import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn } from '@angular/router';
import { IgniteSubscriptionStatusService } from '@clubhub/services/ignite-subscription-status.service';
import { TwoFactorVerificationService } from '@shared/services/two-factor-verification.service';
import { firstValueFrom } from 'rxjs';

export const verifyTwoFactorGuard: CanActivateFn = async (next: ActivatedRouteSnapshot) => {
  const isHistoric = next.queryParams.historicResult || next.queryParams.key;

  if (isHistoric) {
    return true;
  }

  const twoFactorVerificationService = inject(TwoFactorVerificationService);
  const subscriptionStatusService = inject(IgniteSubscriptionStatusService);

  const subscriptionStatus = await firstValueFrom(subscriptionStatusService.subscriptionStatus$);

  // We don't need the user to verify if they don't have an active subscription.
  if (!subscriptionStatus.active) {
    return true;
  }

  try {
    await twoFactorVerificationService.assertVerified();
    return true;
  } catch {
    return false;
  }
};
